
import { createSlice } from "@reduxjs/toolkit";
const positionsSlice = createSlice({
    name: "department",
    initialState: {
        creatposition: {
            isFetching: false,
            error: false,
            success: false
        },
        editposition: {
            isFetching: false,
            error: false,
            success: false
        },
        positions: {
            listpositions: null,
            isFetching: false,
            error: false,
        }
        
    },
    reducers: {
        editPositionStart: (state) => {
            state.editposition.isFetching = true;
        },
        editPositionSuccess: (state) => {
            state.editposition.isFetching = false;
            state.editposition.error = false;
            state.editposition.success = true;
        },
        editPositionFailed: (state) => {
            state.editposition.isFetching = false;
            state.editposition.error = true;
            state.editposition.success = false;
        },
        createPositionStart: (state) => {
            state.creatposition.isFetching = true;
        },
        createPositionSuccess: (state) => {
            state.creatposition.isFetching = false;
            state.creatposition.error = false;
            state.creatposition.success = true;
        },
        createPositionFailed: (state) => {
            state.creatposition.isFetching = false;
            state.creatposition.error = true;
            state.creatposition.success = false;
        },
        getPositionStart: (state) => {
            state.positions.isFetching = true;
        },
        getPositionSuccess: (state, action) => {
            state.positions.isFetching = false;
            state.positions.listpositions = action.payload;
            state.positions.error = false;
        },
        getPositionFailed: (state) => {
            state.positions.isFetching = false;
            state.positions.error = true;
        },
        
    }
});
export const {
    editPositionStart,
    editPositionSuccess,
    editPositionFailed,
    createPositionStart,
    createPositionSuccess,
    createPositionFailed,
    getPositionStart,
    getPositionSuccess,
    getPositionFailed
} = positionsSlice.actions;
export default positionsSlice.reducer;
